import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import CountUp from "react-countup";
import { Carousel } from "react-bootstrap";
import TeamCarousel from "../components/TeamCarousel";

const carouselStyles = `
#aboutCarousel .media-shell{
width:100%;
position:relative;
background:#000;
border-radius:12px;
overflow:hidden;
aspect-ratio:16/9;
}
@media (min-width:992px){ #aboutCarousel .media-shell.landscape{ aspect-ratio:21/9; } }
@media (max-width:576px){ #aboutCarousel .media-shell.landscape{ aspect-ratio:4/3; } }
#aboutCarousel .media-shell.portrait-shell{ aspect-ratio:1/1; }
@media (min-width:992px){ #aboutCarousel .media-shell.portrait-shell{ aspect-ratio:4/3; } }
#aboutCarousel .bg-fill{
position:absolute; inset:0; z-index:0;
background-size:cover; background-position:center;
filter:blur(22px) brightness(.8);
transform:scale(1.15);
}
#aboutCarousel .bg-video{
position:absolute; inset:0; z-index:0;
width:100%; height:100%; object-fit:cover;
filter:blur(22px) brightness(.8);
transform:scale(1.15);
}
#aboutCarousel .media{
position:relative; z-index:1;
width:100%; height:100%;
display:block;
object-fit:cover; object-position:center;
}
#aboutCarousel .media.portrait{ object-fit:contain; }
#aboutCarousel .ribbon {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 2;
  background-color: rgba(0, 123, 255, 0.9);
  color: #fff;
  font-size: 0.85rem;
  padding: 0.4rem 0.7rem;
  border-radius: 0.5rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
`;

const MEDIA = [
  { src: "/assets/about21.jpeg", caption: "DEAL VEHICULES ELECTRIQUES" },
  { src: "/assets/about13.jpg", caption: "...." },
  { src: "/assets/about1.jpg", caption: "...." },
  { src: "/assets/about16.jpeg", caption: "..." },
  { src: "/assets/about2.jpg", caption: "...." },
  { src: "/assets/about17.jpeg", caption: "...." },
  { src: "/assets/about3.jpg", caption: "...." },
  { src: "/assets/about18.jpeg", caption: "...." },
  { src: "/assets/about4.jpg", caption: "...." },
  { src: "/assets/about19.jpeg", caption: "...." },
  { src: "/assets/about5.jpg", caption: "...." },
  { src: "/assets/about20.jpeg", caption: "...." },
  { src: "/assets/hero-video6.mp4", caption: "🎬 Vidéo officielle de présentation" },
];

export default function AboutPage() {
  const [slideIndex, setSlideIndex] = useState(0);
  const [isPortrait, setIsPortrait] = useState({});
  const videoRefs = useRef({});

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  useEffect(() => {
    Object.entries(videoRefs.current).forEach(([i, v]) => {
      if (!v) return;
      if (+i === slideIndex) v.play().catch(() => {});
      else {
        v.pause();
        v.currentTime = 0;
      }
    });
  }, [slideIndex]);

  return (
    <div className="bg-light">
      <style>{carouselStyles}</style>

      <Helmet>
        <title>À propos de THE BRIDGE SARL | Commande, Vente et Importation de Véhicules au Togo</title>
        <meta
          name="description"
          content="THE BRIDGE SARL est spécialisée dans la commande personnalisée, la vente et l’importation de véhicules neufs et d’occasions au Togo. Votre partenaire auto de confiance en Afrique."
        />
        <meta
          name="keywords"
          content="The bridge, commande voiture Togo, importation véhicule Afrique, vente voiture occasions, The Bridge SARL, voiture neuve Togo, service automobile Lomé, voiture personnalisée Togo"
        />
        <meta name="author" content="The Bridge of World" />
        <meta property="og:title" content="THE BRIDGE SARL | Vente, Commande & Importation de Voitures" />
        <meta
          property="og:description"
          content="Découvrez THE BRIDGE SARL : importation, vente et commandes personnalisées de véhicules adaptés à vos besoins. Qualité, service et fiabilité au Togo."
        />
        <meta property="og:url" content="https://thebridgeofworld.com/a-propos" />
        <meta property="og:type" content="website" />
      </Helmet>

      <MenuNav />
      <MobileMenu />

      <section className="bg-dark text-white text-center py-5">
        <div className="container">
          <h1 className="display-5 fw-bold">Qui sommes-nous ? | THE BRIDGE SARL</h1>
          <p className="lead">
            Votre partenaire de confiance pour les véhicules neufs et d'occasions, pièces et services d'entretien au Togo ainsi que dans la sous région.
          </p>
        </div>
      </section>

      <section className="py-5 bg-white">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6" data-aos="fade-right">
              <h3 className="fw-bold mb-3 text-primary">Objectifs de l'Entreprise</h3>
              <p>
                <strong><em>THE BRIDGE SARL</em></strong> est spécialisée dans l'importation et la vente de véhicules neufs et d'occasions, ainsi que de leurs pièces et accessoires. En complément, nous proposons des services d'entretien, de réparation et de conseil, afin d'assurer à nos clients une expérience automobile optimale.
              </p>
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <h3 className="fw-bold mb-3 text-primary">Opportunités de Marché</h3>
              <p>
                Le marché automobile au Togo connaît une demande croissante pour des véhicules fiables et de haute qualité, qu'ils soient neufs ou d'occasions. Par ailleurs, les besoins en services d'entretien et de réparation sont en forte progression, ouvrant ainsi de nouvelles perspectives de croissance pour le secteur.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light border-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="fade-up">
              <h3 className="fw-bold text-primary mb-4">Description de l'Entreprise</h3>
              <p>
                Issue de l'expertise <strong>d'ELIAKIM CORPORATE</strong>, THE BRIDGE SARL est une société de commerce import-export spécialisée dans la vente de véhicules neufs et d'occasions, ainsi que de leurs pièces et accessoires.
              </p>
              <p>
                Fondée le 12 février 2025, elle est dirigée par <em>M. ADOBAH Kossi Firmin</em>. Résolument tournée vers l'innovation et la satisfaction client, THE BRIDGE SARL s'engage à offrir des produits et services de qualité, répondant aux besoins du marché automobile.
              </p>
            </div>
            <div className="col-lg-6" data-aos="zoom-in">
              <img src="/assets/about6.jpg" className="img-fluid rounded shadow" alt="Présentation de THE BRIDGE" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-white border-top">
        <div className="container">
          <h3 className="text-center fw-bold mb-5 text-primary">Pourquoi choisir THE BRIDGE ?</h3>
          <div className="row g-4 text-center">
            <div className="col-md-4" data-aos="fade-up">
              <i className="bi bi-shield-check text-success fs-1"></i>
              <h5 className="fw-semibold mt-3">Fiabilité & Sécurité</h5>
              <p className="text-muted">Des véhicules soigneusement inspectés et certifiés pour une tranquillité d'esprit absolue.</p>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
              <i className="bi bi-currency-exchange text-primary fs-1"></i>
              <h5 className="fw-semibold mt-3">Transparence & Prix</h5>
              <p className="text-muted">Des tarifs compétitifs sans frais cachés : ce que vous voyez est exactement ce que vous payez.</p>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-people text-danger fs-1"></i>
              <h5 className="fw-semibold mt-3">Service Client Dédié</h5>
              <p className="text-muted">Une équipe attentive et disponible pour vous accompagner avant, pendant et après votre achat.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light border-top">
        <div className="container">
          <div className="text-center mb-5">
            <h3 className="fw-bold text-primary">Nos Engagements</h3>
            <p className="text-muted">Chez THE BRIDGE, nous nous engageons à offrir un service exceptionnel et à garantir la satisfaction de chaque client.</p>
          </div>
          <div className="row g-4">
            <div className="col-md-6" data-aos="fade-right">
              <ul className="list-group list-group-flush">
                <li className="list-group-item">✔️ Importation directe des meilleures marques – Des véhicules sélectionnés avec soin pour assurer qualité et fiabilité.</li>
                <li className="list-group-item">✔️ Contrôle qualité avant livraison – Une inspection rigoureuse pour garantir la conformité et la performance de chaque véhicule.</li>
                <li className="list-group-item">✔️ Accompagnement pour immatriculation & formalités – Un soutien personnalisé pour simplifier chaque démarche administrative.</li>
              </ul>
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <ul className="list-group list-group-flush">
                <li className="list-group-item">✔️ Entretien & pièces garanties – Des services de maintenance et des pièces certifiées pour une tranquillité d'esprit totale.</li>
                <li className="list-group-item">✔️ Disponibilité des pièces détachées – Un stock permanent pour répondre rapidement aux besoins de remplacement.</li>
                <li className="list-group-item">✔️ Réactivité du service après-vente – Une équipe à l'écoute pour une prise en charge rapide et efficace.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container text-center">
          <div className="row g-4">
            {["Véhicules livrés", "Clients satisfaits", "Marques disponibles"].map((label, i) => (
              <div className="col-md-4" key={i}>
                <h2 className="text-primary fw-bold">
                  <CountUp end={i === 0 ? 1000 : i === 1 ? 500 : 25} duration={2} />+
                </h2>
                <p>{label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TeamCarousel />

      <section className="py-5 bg-white" id="aboutCarousel">
        <div className="container">
          <h2 className="text-center fw-bold mb-4">Affichage de l'entreprise</h2>
          <Carousel
            indicators
            interval={5000}
            fade
            activeIndex={slideIndex}
            onSelect={(i) => setSlideIndex(i)}
            className="shadow rounded overflow-hidden"
          >
            {MEDIA.map(({ src, caption }, i) => {
              const isVideo = /\.(mp4|webm|ogg)$/i.test(src);
              const shellClass = isPortrait[i] ? "media-shell portrait-shell" : "media-shell landscape";

              return (
                <Carousel.Item key={i}>
                  <div className={shellClass}>
                    {!isVideo ? (
                      <div className="bg-fill" aria-hidden style={{ backgroundImage: `url(${src})` }} />
                    ) : (
                      <video className="bg-video" src={src} muted loop playsInline aria-hidden />
                    )}

                    {isVideo ? (
                      <video
                        ref={(el) => (videoRefs.current[i] = el)}
                        src={src}
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        className={`media ${isPortrait[i] ? "portrait" : ""}`}
                        onLoadedMetadata={(e) => {
                          const v = e.currentTarget;
                          setIsPortrait((p) => ({ ...p, [i]: v.videoHeight > v.videoWidth }));
                        }}
                      />
                    ) : (
                      <img
                        src={src}
                        alt={`Média ${i + 1}`}
                        loading="lazy"
                        draggable="false"
                        className={`media ${isPortrait[i] ? "portrait" : ""}`}
                        onLoad={(e) => {
                          const im = e.currentTarget;
                          setIsPortrait((p) => ({ ...p, [i]: im.naturalHeight > im.naturalWidth }));
                        }}
                      />
                    )}

                    {caption && <div className="ribbon">{caption}</div>}
                  </div>
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
      </section>

      <section className="py-5 text-white" style={{ backgroundColor: "#0C1E47" }}>
        <div className="container text-center">
          <h4 className="fw-bold mb-3">Prêt à acheter votre prochain véhicule ?</h4>
          <p className="mb-4">Contactez notre équipe pour découvrir nos offres disponibles et personnalisées.</p>
          <Link to="/contact" className="btn btn-outline-light px-4 py-2">
            Nous contacter
          </Link>
        </div>
      </section>

      <footer style={{ backgroundColor: "#0C1E47" }} className="text-white pt-5 pb-3 mt-5 border-top">
        <div className="container">
          <div className="row gy-4">
            <div className="col-md-4">
              <div className="logo-wrapper">
                <img src="/BRIDGE BLANC.png" alt="THE BRIDGE logo" width="180" className="mb-3" />
              </div>
              <p style={{ color: "#F7931E", fontWeight: 500 }}>Let’s connect the world together</p>
              <p className="small text-white-50">
                THE BRIDGE est votre partenaire de confiance pour l’achat de véhicules fiables à travers le monde.
              </p>
            </div>

            <div className="col-md-4">
              <h6 className="text-uppercase fw-semibold mb-3">Navigation</h6>
              <ul className="list-unstyled">
                <li>
                  <Link to="/" className="text-white-50 text-decoration-none">Accueil</Link>
                </li>
                <li>
                  <Link to="/catalogue" className="text-white-50 text-decoration-none">Nos véhicules</Link>
                </li>
                <li>
                  <Link to="/contact" className="text-white-50 text-decoration-none">Contact</Link>
                </li>
                <li>
                  <Link to="/mentions-legales" className="text-white-50 text-decoration-none">Mentions légales</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-4">
              <h6 className="text-uppercase fw-semibold mb-3">Nous contacter</h6>
              <p className="text-white-50 small mb-1"><i className="bi bi-geo-alt me-2"></i>Lomé, Togo</p>
              <p className="text-white-50 small mb-1"><i className="bi bi-envelope me-2"></i>contact@thebridgeofworld.com</p>
              <p className="text-white-50 small mb-0"><i className="bi bi-phone me-2"></i>+228 78 81 54 94 / +228 99 41 00 41 / +228 93 90 72 95</p>
            </div>
          </div>

          <div className="text-center mt-4 pt-3 border-top border-secondary text-white-50 small">
            © {new Date().getFullYear()} THE BRIDGE — Tous droits réservés
          </div>
        </div>
      </footer>
    </div>
  );
}
